<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const containerClass = computed(() => {
    return (
        route.meta.containerClass ??
        "col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4"
    );
});
</script>

<template>
    <div class="background-image min-vh-100 d-flex flex-lg-row">
        <div class="background-overlay"></div>

        <div
            id="right-container"
            class="d-flex justify-content-center align-items-center"
        >
            <div class="my-5 mx-1 row justify-content-center flex-grow-1">
                <div :class="containerClass">
                    <div
                        class="content-box px-md-4 px-2 py-md-3 py-2 mb-2 mt-2 position-relative"
                    >
                        <div
                            class="text-center mb-1 mt-3"
                            v-if="!route.meta.isHideLogo"
                        >
                            <div class="me-2 d-flex justify-content-center">
                                <img
                                    id="logo"
                                    :src="'/assets/images/tds-logo.png'"
                                    class="my-3 img-fluid system-logo"
                                    alt="logo"
                                />
                                <img
                                    id="logo"
                                    :src="'/assets/images/tims-logo.png'"
                                    class="my-3 img-fluid system-logo"
                                    alt="logo"
                                />
                            </div>
                        </div>

                        <slot />
                    </div>

                    <div class="helpdesk-bar" role="contentinfo">
                        <div class="helpdesk-inner">
                            <span>Helpdesk</span>
                            <span class="separator">|</span>
                            <span>Tourism Statistics Unit</span>
                            <span class="separator">|</span>
                            <a href="mailto:data@tourism.gov.bn" class="email"
                                >data@tourism.gov.bn</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.system-logo {
    width: 175px;
}

.background-image {
    background-image: url("/assets/images/tds-background.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
}

.background-overlay {
    background: rgba(255, 255, 255, 0.3);
    position: fixed;
    z-index: 2;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
}

.circle-wrapper {
    width: 110px;
    height: 110px;
    background: white;
    border-radius: 90px;
}

#right-container {
    flex-grow: 1;
    min-height: 200px;
    z-index: 5;
}

.auth-title-small {
    font-size: 45px;
}

.auth-title-large {
    font-size: 90px;
    line-height: 80px;
    font-weight: bold;
}
.content-box {
    background-color: rgba(255, 255, 255);
    border-radius: 20px;
    max-width: 1000px;
    margin: 0 auto;
}

@media (max-width: 768px) {
    .content-box {
        margin: 0 10px;
    }
}

.helpdesk-bar {
    /* position: fixed; */
    background: rgba(0, 0, 0, 0.78);
    color: #fff;
    padding: 12px 18px;
    border-radius: 8px;
    z-index: 7;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    text-align: center;
}

.helpdesk-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 0.8rem;
}

.helpdesk-inner .separator {
    opacity: 0.85;
}

.helpdesk-inner .email {
    color: #fff;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .helpdesk-bar {
        padding: 10px 14px;
    }
    .helpdesk-inner {
        flex-wrap: wrap;
        gap: 5px;
    }
}
</style>
